import React, { useEffect, useState } from 'react'

// Translation
import { useTranslation } from 'react-multi-lang'

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { addRoleSlice, addRoleState } from './AddModalSlice'
import { permissionsSlice } from '../Permissions/PermissionsSlice'
import { rolesSlice } from '../RolesSlice'
import { MySuccessMark } from '../../../components/Loader/Loader'


// Components
import Modal from '../../../components/Modal/Modal'
import { InputField } from '../../../components/FormElements/FormElements'
import { WhiteboxLoader } from '../../../components/Loader/Loader'
import { useNotification } from '../../../services/usenotification'
import PermissionModal from './permissionModal'
import { havePermission } from '../../../services/hoc/permissions'
import { useAPI } from '../../../services/hoc/useAPI'

export default () => {

    // Translation
    const t = useTranslation()
    const [isLoading,setIsLoading]=useState(false)
    const [succeed,setSucceed]=useState(false)
    const {alertError500,alert}=useNotification()
    let [nodes,setNode]=useState<any[]>([])
    const [checked, setChecked] = useState<string[]>([])
    const [open,setOpen]=useState(false)
   
    // Redux
    const dispatch = useDispatch()
    const state = useSelector((state: { add_role: addRoleState }) => state.add_role)
const ENDPOINTS = useAPI()

    // Hooks
    const [showErrors, setShowErrors] = useState<boolean>(false)

    // Add role
    const showPermission=(id:number)=>{
     
        ENDPOINTS.roles().show({id}).
        then((res:any)=>{
            if (res.data.data && res.data.data.permissions){
                let checked_values:string[]=[]
          
                res.data.data.permissions.map((ele:any)=>{
                    if (!checked_values.includes(ele.id)){
                        checked_values.push(ele.id)
                    }
                  
                    
                })
               
                setChecked(checked_values)
            }
        })
        .catch((err:any)=>
            alertError500(err)
            )
    }
    const fetchData =(id:number|null)=>{
    
        ENDPOINTS.roles().permissions({page:1,page_size:100}).
        then((res:any)=>{
            
            if (res.data.data ){
                let checked_values:string[]=[]
                let thenodes:any={}
             
                res.data.data.map((ele:any)=>{
                   thenodes[ele.category]=ele.permissions.map((elem:any)=>
                     ({value:elem.id,label:elem.name,level:elem.level}))
                    
                })
                setNode(Object.keys(thenodes).map((ele:string)=>({value:ele,label:ele
                    ,children:thenodes[ele as any]}))
                )
                
            }
            if (id){
                showPermission(id)
            }
        })
        .catch((err:any)=>
            alertError500(err)
            )
    }
    const add = (e: React.FormEvent<HTMLFormElement>) => {

        e.preventDefault()

        if (state.fields.name === "") {
            setShowErrors(true)
            return
        }

      setIsLoading(true)
        const endpoint = state.editId ? ENDPOINTS.roles().update : ENDPOINTS.roles().store
        endpoint({ id: state.editId, name: state.fields.name || "", permissions: checked.map(ele=>Number(ele)) || [] })
            .then((response: any) => {
                setIsLoading(false)
                setSucceed(true)
                setChecked([])
                if (state.editId){
                    dispatch(rolesSlice.actions.updateRole(
                        { id: response.data.data.id, name: response.data.data.name
                            , permissions: response.data.data.permissions }
                        ))
                }
                else {

                    dispatch(rolesSlice.actions.addRoles([
                        { id: response.data.data.id, 
                        name: response.data.data.name, 
                        permissions: response.data.data.permissions }]))
                }
                // dispatch(addRoleSlice.actions.setIsSuccess(true))
                // setTimeout(() => {
                //     toggle()
                //     dispatch(rolesSlice.actions.addRoles([{ id: response.data.data.id, name: response.data.data.name, permissions: response.data.data.permissions }]))
                //     dispatch(showRoleSlice.actions.setIsOpen(true))
                //     dispatch(showRoleSlice.actions.setRoleId(response.data.data.id))
                //     dispatch(showRoleSlice.actions.setPermisions(response.data.data.permissions))
                //     dispatch(showRoleSlice.actions.setData({ name: response.data.data.name || "", permissions: response.data.data.permissions?.map((permission: any) => permission.name) || [] }))
                // }, 1000);
             
            })
            .catch((err:any)=>
            {
                setIsLoading(false)

                alertError500(err)
            }
            )

    }
useEffect(()=>{
fetchData(state.editId)
},[state.editId])

    const toggle = () => {
        dispatch(addRoleSlice.actions.setIsOpen(!state.isOpen))
        dispatch(addRoleSlice.actions.init())
    }


    return (
        <Modal open={state.isOpen} toggle={toggle}>

            {isLoading ? <WhiteboxLoader /> : ""}
            {<MySuccessMark 
            setSucceed={setSucceed}
            succeed={succeed}
            />}
            {/* {state.isSuccess ? <SuccessMark /> : ""} */}

            <h2 className="text-center" style={{ margin: "0 0 20px" }}>{state.editId ? t("edit_role") : t("add_to_roles")}</h2>

            <form onSubmit={add} style={{ width: 400, maxWidth: "100%" }}>

                <InputField
                    label={t("role_name") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch(addRoleSlice.actions.set({ name: e.target.value }))}
                    value={state.fields.name}
                    error={(showErrors && state.fields.name === "") ? t("required_error") : ""}
                />

                <button className="modal-secondary-botton" onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                    e.preventDefault()
                    if (havePermission("Show Permissions")) {

                        setOpen(true)
                        dispatch(permissionsSlice.actions.setSelectedIds(state.fields.permissions || []))
                    }
                    else {

                        alert({en:"You don't have permission to Show Permissions",ar:"لا تملك صلاحية عرض الصلاحيات"},'info')
                    }
                }}>{t("manage_permissions")}</button>

                <button className="button round bg-gold color-white margin-top-30" 
                style={{ padding: "0 80px", marginBottom: 5 }}>
                    {t("save") }
                    </button>

            </form>
            {
                <PermissionModal
                nodes={nodes}
                checked={checked}
                setChecked={setChecked}
                setOpen={setOpen} 
            
               open={open}

                />
            }
            {/* <PermissionsModal set={(ids: number[]) => dispatch(addRoleSlice.actions.set({ permissions: ids }))} /> */}

        </Modal>
    )

}